import { Button, Modal, Spin, Table } from 'antd';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { getDiariosObra } from '@actions/diariosActions';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { EyeOutlined } from '@ant-design/icons';
import { getColumnSearchProps, naturalSorter, orderDate } from '@utils/filterandsort';
import { useAppDispatch, useAppSelector } from '@config/reduxStore';

function DiariosModal({
  visible,
  setVisible,
  id,
}: {
  visible: boolean;
  setVisible: Dispatch<SetStateAction<boolean>>;
  id: number;
}) {
  const { diarios, loadingDiarios } = useAppSelector((state) => state.diarios);
  const dispatch = useAppDispatch();
  const [filters, setFilters] = useState(null);
  useEffect(() => {
    if (id) dispatch(getDiariosObra(id));
  }, [id, dispatch]);
  return (
    <Modal
      open={visible}
      onCancel={() => setVisible(false)}
      title="Diarios"
      footer={[<Button onClick={() => setVisible(false)}>Fechar</Button>]}
    >
      <Spin spinning={loadingDiarios}>
        <Table
          size="small"
          dataSource={diarios}
          rowKey="id"
          onChange={(pagination, filters, sorter) => setFilters({ pagination, filters, sorter })}
        >
          <Table.Column
            dataIndex="id"
            render={(v) => (
              <Link to={`/Diarios/${v}`} target="_blank">
                <Button size="small" icon={<EyeOutlined />} />
              </Link>
            )}
          />
          <Table.Column
            title="Data"
            dataIndex="data"
            sorter={(a, b) => orderDate(a.data, b.data)}
            render={(v) => moment(v).format('DD/MM/YYYY')}
            {...getColumnSearchProps('data', 'daterange', 'Data', filters)}
          />
          <Table.Column
            title="Auditor"
            dataIndex="auditor"
            sorter={(a, b) => naturalSorter(a.auditor, b.auditor)}
            {...getColumnSearchProps('auditor', 'string', 'Auditor', filters)}
          />
        </Table>
      </Spin>
    </Modal>
  );
}

export default DiariosModal;
